import GoogleMapReact from "google-map-react";
import React, { Component } from "react";
import Logo from "../img/logo-k.png";

const Pin = () => (
  <div>
    <img
      src={Logo}
      style={{
        width: "20px",
        position: "relative",
        minWidth: "60px",
        float: "left",
      }}
    ></img>
    {/* <div className ="pin-arrow"></div> */}
  </div>
);

const Card = () => (
  <div className="map-card">
    <div className="map-card--content">
      <h3 className="map-card--header">VietPho Cuisine</h3>
      <p className="map-card--info"> Leipziger Str. 38 </p>
      <p className="map-card--info"> 60487 Frankfurt am Main </p>
      <p className="map-card--info"> Tel. 069 50929222 </p>
      <ul className="icons">
        <li>
          <a
            style={{ color: "black" }}
            href="https://www.facebook.com/VietPho-Cuisine-334073757070790/"
            className="icon fa-facebook"
          >
            <span className="label">Facebook</span>
          </a>
        </li>
        <li>
          <a
            style={{ color: "black" }}
            href="https://www.instagram.com/vietpho.cuisine/"
            className="icon fa-instagram"
          >
            <span className="label">Instagram</span>
          </a>
        </li>
      </ul>

      <p className="map-card--info">
        {" "}
        <b>Öffnungszeiten:</b>{" "}
      </p>

      <table style={{ fontSize: "14px" }}>
        <tbody>
          <tr>
            <td>Montag bis Freitag</td>
            <td>
              <i>12:00 - 15:00, 17:00 - 22:00</i>
            </td>
          </tr>
          <tr>
            <td>Samstag</td>
            <td>
              <i>12:00 - 23:00</i>
            </td>
          </tr>
          <tr>
            <td>Sonntag</td>
            <td>
              <i>Geschlossen</i>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  </div>
);

export default class Map extends Component {
  static defaultProps = {
    mapKey: "AIzaSyBlvl1450nhgvJfUqegXbLuE95oD7FWWZ8",
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBlvl1450nhgvJfUqegXbLuE95oD7FWWZ8&v=3.exp&libraries=geometry,drawing,places",
    center: { lat: 50.1226, lng: 8.6465 },
    zoom: 16,
    disableDefaultUI: true,
    zoomControl: false,
    scaleControl: false,
    language: "de",
  };

  render() {
    return (
      <div className="google-map map-wrapper" id="anfahrt">
        <GoogleMapReact
          apiKey={this.props.mapKey}
          language={this.props.language}
          bootstrapURLKeys={this.props.mapKey}
          center={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <Pin lng={8.64716} lat={50.12256} />
        </GoogleMapReact>
        <Card />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/map.js